import useSelector from '@redux/typedHooks';

// Get the site structure node
export const useSiteStructure = (slug: string | undefined) =>
  useSelector((state) => slug && state.sitestructure.mappedCategories[slug]) || undefined;

export const useGlobalTags = (url: string | undefined) =>
  useSelector((state) => url && state.sitestructure.globalTags[url]) || undefined;
